import React from 'react';
import Icon from '../../../AppIcon';

const MetricsOverview = () => {
  const overviewMetrics = [
    {
      id: 1,
      title: "Total Matches",
      value: "2,847",
      change: "+12.5%",
      changeType: "positive",
      icon: "Target",
      description: "Successful startup-corporate connections",
      trend: [65, 78, 82, 95, 88, 92, 100]
    },
    {
      id: 2,
      title: "Active Programs",
      value: "156",
      change: "+8.3%",
      changeType: "positive",
      icon: "Briefcase",
      description: "Currently running scouting programs",
      trend: [45, 52, 48, 65, 72, 68, 75]
    },
    {
      id: 3,
      title: "Conversion Rate",
      value: "34.2%",
      change: "-2.1%",
      changeType: "negative",
      icon: "TrendingUp",
      description: "Referral to partnership conversion",
      trend: [88, 85, 90, 82, 78, 75, 80]
    },
    {
      id: 4,
      title: "Revenue Generated",
      value: "$4.2M",
      change: "+18.7%",
      changeType: "positive",
      icon: "DollarSign",
      description: "Total platform revenue this quarter",
      trend: [30, 45, 55, 70, 85, 95, 100]
    }
  ];

  const renderMiniChart = (trend) => {
    const max = Math.max(...trend);
    const points = trend?.map((value, index) => {
      const x = (index / (trend?.length - 1)) * 60;
      const y = 20 - (value / max) * 15;
      return `${x},${y}`;
    })?.join(' ');

    return (
      <svg width="60" height="20" className="ml-auto">
        <polyline
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          points={points}
        />
      </svg>
    );
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {overviewMetrics?.map((metric) => (
        <div
          key={metric?.id}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-all duration-200"
        >
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={metric?.icon} size={20} className="text-primary" />
              </div>
              <div>
                <h3 className="text-sm font-medium text-muted-foreground">
                  {metric?.title}
                </h3>
                <p className="text-2xl font-bold text-foreground mt-1">
                  {metric?.value}
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <span
                className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                  metric?.changeType === 'positive' ?'bg-success/10 text-success' :'bg-destructive/10 text-destructive'
                }`}
              >
                <Icon
                  name={metric?.changeType === 'positive' ? 'ArrowUp' : 'ArrowDown'}
                  size={12}
                  className="mr-1"
                />
                {metric?.change}
              </span>
            </div>
            <div className="text-muted-foreground">
              {renderMiniChart(metric?.trend)}
            </div>
          </div>

          <p className="text-xs text-muted-foreground mt-3">
            {metric?.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default MetricsOverview;